import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { ISubscriptionRulePayload, TSubscriptionRule } from "../types";

export const createSubscriptionRule = async (
  props: ISubscriptionRulePayload
): Promise<TSubscriptionRule> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/subscription-rules`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const { token, ...body } = props;
  const res = await axios.post<TSubscriptionRule>(url, body, config);
  return res.data;
};

export const useCreateSubscriptionRule = () => {
  return useMutation(createSubscriptionRule);
};
